/* ================================================== */
/* ACCESSIBILITY > Disable Tabindex
/* ================================================== */

function resetTabindex() {
	$('[data-tabindex]').each(function(index, element) {
		$(element).attr('tabindex', $(element).attr('data-tabindex')).removeAttr('data-tabindex');
	});
}